/**
 * Converts a string number to budget format, e.g. 250000 -> $250.000
 * @param {string} str
 * @returns {string}
 */
export default function convertToBudgetFormat(str) {
    const num = parseInt(str);
    if (typeof num !== "number" || isNaN(num)) return "";
    // Format with dot as thousands separator, no decimals, and $ prefix
    return "$" + num.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/,/g, '.');
}
